<template>
  <div class="fiat-kyc-form">
    <p v-if="isSuccessful">KYC document uploaded successfully. Our KYC team will now processed your application and update your KYC status. Stay tuned !</p>
    <form onsubmit.prevent="" v-else-if="!isLoading">
      <label>Document type
        <select v-model="docType">
          <option value="passport">Passport</option>
          <option value="national_id">National ID</option>
          <option value="driving_license">Driving License</option>
        </select>
      </label>
      <label>
        Upload KYC documents. Documents need to be less than 20MB and corresponding to the type you chose above.
        <VueFileAgent
          class="w-100"
          ref="kycFileInputRef"
          :theme="'list'"
          :accept="'image/png,image/jpg,image/jpeg,.pdf'"
          :deletable="true"
          :multiple="true"
          :maxFiles="1"
          :maxSize="'20MB'"
          :helpText="'Upload KYC documents'"
          v-model="kycFileInput"
          @beforedelete="onBeforeDelete($event)"
          @select="handleFileSelect()" />
      </label>
      <ul v-if="isFailed" class="error">
        <li v-if="!errors">The KYC upload failed. Please try again.</li>
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
    </form>
    <div class="vs-con-loading__container" id="kyc-upload-loader" :enabled="isLoading"></div>
  </div>
</template>
<script>
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

import Vue from 'vue';

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);

export default {
  props: {
    accountId: '',
    shouldResetKycForm: {
      type: Boolean,
      default: false,
    },
    confirmOrder: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0)',
    },
  },
  data() {
    return {
      kycFileInput: [],
      docType: 'passport',
      category: 'identity_verification',
      isLoading: false,
      isSuccessful: false,
      isFailed: false,
      errors: [],
    };
  },
  methods: {
    uploadKycDocument() {
      this.errors = [];
      if (!this.isFormValid()) {
        this.isLoading = false;
        this.isFailed = true;
        this.$emit('processFail');
        return;
      }
      this.isLoading = true;
      this.isSuccessful = false;
      this.isFailed = false;
      this.getFiatApiToken().then((token) => {
        const data = this.buildPayload();
        this.$store.dispatch('uploadFiatKycDocument', { token, data })
          .then(() => {
            this.isLoading = false;
            this.isFailed = false;
            this.isSuccessful = true;
            this.$emit('processSuccess');
          })
          .catch((error) => {
            this.isLoading = false;
            this.isFailed = true;
            this.isSuccessful = false;
            this.errors.push(error);
            this.$emit('processFail');
          });
      }).catch((error) => {
        this.isLoading = false;
        this.isFailed = true;
        this.isSuccessful = false;
        this.errors.push(error);
        this.$emit('processFail');
      });
    },

    onBeforeDelete(fileRecord) {
      this.$emit('fileDeleted');
      this.$refs.kycFileInputRef.deleteFileRecord(fileRecord);
    },

    buildPayload() {
      if (!this.isFormValid()) { return; }
      const payload = {
        owner_id: this.accountId,
        category: this.category,
        document_type: this.docType,
        file: this.kycFileInput[0].file,
      };
      return payload;
    },

    async getFiatApiToken() {
      const merchantKey = this.$store.getters.activeMerchantKeyGetter;
      const response = await this.$store.dispatch('getMerchantPaymentRequestToken', merchantKey);
      this.requestToken = response.data.access_token;
      return response.data.access_token;
    },

    handleFileSelect() {
      this.$emit('fileSelected');
    },

    isFormValid() {
      let isValid = true;
      if (!this.accountId) {
        this.isFailed = true;
        this.errors.push('No account id provided.');
        isValid = false;
      }
      if (!this.kycFileInput.length) {
        this.isFailed = true;
        this.errors.push('No KYC document provided.');
        isValid = false;
      }
      return isValid;
    },
  },
  watch: {
    shouldResetKycForm() {
      this.kycFileInput = [];
      this.$emit('resetKycForm');
    },

    confirmOrder(newVal) {
      if (newVal) {
        this.uploadKycDocument();
      }
    },

    isLoading(newVal) {
      const ID = '#kyc-upload-loader';
      if (newVal) {
        this.$vs.loading({
          container: ID,
          scale: 1,
          background: this.backgroundColor,
          text: 'Uploading your KYC document...',
        });
      } else {
        this.$vs.loading.close(ID + ' > .con-vs-loading');
      }
    }
  },
};
</script>
<style lang="scss">
.fiat-kyc-form {
  display: block;
  width: 100%;

  label {
    display: flex;
    margin-bottom: $margin-m;
    flex-direction: column;

    select {
      display: block;
      width: 100%;
      margin-top: $margin-s;
      height: 38px;
      border-radius: 5px;
      padding: 3px;
      border: 0.5px solid lightgrey;
    }
  }

  & > p {
    margin-bottom: $margin-l;
  }

  .error {
    color: red;
  }
}

#kyc-upload-loader {
  width: 100%;

  &[enabled] {
    height: 200px;
  }
}
</style>